import { Stack, Typography } from "@mui/material";
import { useBrandingStore } from "../../stores/Branding";

export default function FollowUs() {
  const branding = useBrandingStore((s) => s.branding);

  return (
    <Stack spacing={1} direction="column">
      {branding?.links?.facebook.label && (
        <Stack
          component="a"
          sx={{
            textDecoration: "none",
          }}
          target="_blank"
          href={branding?.links?.facebook.link}
          direction={"row"}
          spacing={1}
        >
          <img
            src={require("../../assets/facebook-new.png")}
            style={{ height: 20, width: 20 }}
          />
          <Typography
            sx={{
              color: (theme) => theme.palette.primary.contrastText,
              fontWeight: 300,
            }}
          >
            {branding?.links?.facebook.label}
          </Typography>
        </Stack>
      )}

      {branding?.links?.linkedin.label && (
        <Stack
          component="a"
          sx={{
            textDecoration: "none",
          }}
          target="_blank"
          href={branding?.links?.linkedin.link}
          direction={"row"}
          spacing={1}
        >
          <img
            src={require("../../assets/linkedin.png")}
            style={{ height: 20, width: 20 }}
          />
          <Typography
            sx={{
              color: (theme) => theme.palette.primary.contrastText,
              fontWeight: 300,
            }}
          >
            {branding?.links?.linkedin.label}
          </Typography>
        </Stack>
      )}

      {branding?.links?.x.label && (
        <Stack
          component="a"
          sx={{
            textDecoration: "none",
          }}
          target="_blank"
          href={branding?.links?.x.link}
          direction={"row"}
          spacing={1}
        >
          <img
            src={require("../../assets/twitterx.png")}
            style={{ height: 20, width: 20 }}
          />
          <Typography
            sx={{
              color: (theme) => theme.palette.primary.contrastText,
              fontWeight: 300,
            }}
          >
            {branding?.links?.x.label}
          </Typography>
        </Stack>
      )}

      {branding?.links?.instagram.label && (
        <Stack
          component="a"
          sx={{
            textDecoration: "none",
          }}
          target="_blank"
          href={branding?.links?.instagram.link}
          direction={"row"}
          spacing={1}
        >
          <img
            src={require("../../assets/instagram.png")}
            style={{ height: 20, width: 20 }}
          />
          <Typography
            sx={{
              color: (theme) => theme.palette.primary.contrastText,
              fontWeight: 300,
            }}
          >
            {branding?.links?.instagram.label}
          </Typography>
        </Stack>
      )}

      {branding?.links?.youtube.label && (
        <Stack
          component="a"
          sx={{
            textDecoration: "none",
          }}
          target="_blank"
          href={branding?.links?.youtube.link}
          direction={"row"}
          spacing={1}
        >
          <img
            src={require("../../assets/youtube.png")}
            style={{ height: 20, width: 20 }}
          />
          <Typography
            sx={{
              color: (theme) => theme.palette.primary.contrastText,
              fontWeight: 300,
            }}
          >
            {branding?.links?.youtube.label}
          </Typography>
        </Stack>
      )}
    </Stack>
  );
}
